import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-sage-light/30" data-id="element-157">
      <div className="max-w-3xl mx-auto" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="bg-white rounded-3xl p-8 sm:p-12 shadow-xl shadow-brown/5 relative overflow-hidden" data-id="element-159">
          {/* Decorative accent */}
          <div className="absolute top-0 left-0 w-2 h-full bg-sage" data-id="element-160"></div>

          <div className="space-y-8" data-id="element-161">
            {/* Opening Hook */}
            <div data-id="element-162">
              <h2 className="text-3xl sm:text-4xl font-heading font-bold text-brown mb-6" data-id="element-163">
                ¿Conoces esa sensación?
              </h2>
              <div className="space-y-5 text-lg text-brown-light leading-relaxed" data-id="element-164">
                <p data-id="element-165">
                  El pecho se aprieta, la respiración se vuelve corta y, de
                  repente, sientes que{' '}
                  <span className="text-brown font-medium" data-id="element-166">
                    el mundo se te viene encima
                  </span>
                  . No es falta de voluntad. Es tu sistema nervioso atrapado en
                  un ciclo de "alarma" que no sabe cómo apagar.
                </p>
              </div>
            </div>

            {/* The Problem */}
            <div data-id="element-167">
              <h3 className="text-2xl font-heading font-semibold text-brown mb-4" data-id="element-168">
                El problema real
              </h3>
              <div className="space-y-5 text-lg text-brown-light leading-relaxed" data-id="element-169">
                <p data-id="element-170">
                  La mayoría de las personas intentan "pensar positivamente"
                  para salir de una crisis de ansiedad. Pero cuando el cortisol
                  inunda tu cuerpo,{' '}
                  <span className="text-brown font-medium" data-id="element-171">
                    la lógica no funciona
                  </span>
                  . Tu cerebro está en modo supervivencia. Necesitas una
                  herramienta que hable el lenguaje de tu cuerpo, no solo de tu
                  mente.
                </p>
                <p className="italic text-brown border-l-4 border-lavender pl-4 py-1" data-id="element-172">
                  Vivir con la incertidumbre de "cuándo será el próximo ataque"
                  es agotador. Te quita el sueño, te quita la energía y te quita
                  la libertad de disfrutar tu presente.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}